import { v2_useBranch, v2_useCart } from '@crocodille/common';
import { assertSome, isNone, unreachable } from '@crocodille/util';
import Link from 'next/link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import * as routing from '../../../routing';
import BBCourierIcon from '../../icons/bb-courier-icon';
import BBPickupIcon from '../../icons/bb-pickup-icon';

import styles from './shipping-status.module.scss';
import { useLastOrderDelivery } from '@hooks/use-last-order-delivery';

const ShippingStatus: React.FC = () => {
  const { data: order } = v2_useCart();

  const { t } = useTranslation();

  const { lastOrderDelivery } = useLastOrderDelivery();

  const deliveryData = !isNone(order) ? order : lastOrderDelivery;

  const { data: branch } = v2_useBranch(deliveryData?.branchCode ?? false);
  if (!deliveryData || isNone(branch)) return null;

  const destination = (() => {
    if (deliveryData.deliveryMethodType === 'atBranch') {
      const branchName = assertSome(branch?.name);

      if (deliveryData.specialDelivery?.type === 'table_delivery') {
        return `${branchName}, ${t('delivery_table', {
          table: deliveryData.specialDelivery.table,
        })}`;
      } else if (deliveryData.specialDelivery?.type === 'gate_delivery') {
        return `${branchName}, ${t('delivery_gate', {
          gate: deliveryData.specialDelivery.gate,
        })}`;
      } else if (
        deliveryData.specialDelivery?.type === 'train_station_delivery'
      ) {
        return `${branchName}, ${t('delivery_train_station', {
          station: deliveryData.specialDelivery.trainStation,
        })}`;
      }

      return branchName;
    } else if (deliveryData.deliveryMethodType === 'courier') {
      const address = assertSome(deliveryData?.shippingAddress);

      return address;
    } else {
      unreachable();
    }
  })();

  let shipping_to = `shipping_to.${deliveryData.shippingMethodType}`;

  if (deliveryData.specialDelivery?.type === 'gate_delivery') {
    shipping_to = 'shipping_to.gate';
  } else if (deliveryData.specialDelivery?.type === 'train_station_delivery') {
    shipping_to = 'shipping_to.train_station';
  }

  return (
    <Link
      href={routing.shippingRoute({ shipping: 'courier' })}
      prefetch={false}
      className={styles.container}
    >
      <div className={styles.iconContainer}>
        {deliveryData.shippingMethodType === 'delivery' ? (
          <BBCourierIcon className={styles.icon} />
        ) : deliveryData.shippingMethodType === 'eatIn' ? (
          // TODO: Replace with restaurant icon
          <BBPickupIcon className={styles.icon} />
        ) : (
          <BBPickupIcon className={styles.icon} />
        )}
      </div>
      <div className={styles.label}>
        <span className={styles.shippingTo}>{t(shipping_to)} </span>
        <span className={styles.destination}>{destination}</span>
      </div>
    </Link>
  );
};

export default ShippingStatus;
